// ticketsagas.js
import { call, put, takeEvery, take, } from 'redux-saga/effects';
import {
  FETCH_TICKETS_REQUEST,
  FETCH_FILTER_TICKETS_REQUEST,
  FETCH_TICKET_REQUEST,
  UPDATE_TICKET_TECHNICIAN_REQUEST,
  UPDATE_TICKET_STATUS_REQUEST,
  CREATE_TICKET_REQUEST,
  UPDATE_TICKET_REQUEST,
  CLOSE_TICKET_REQUEST,
  CREATE_TICKET_COMMENT_REQUEST,
  DELETE_TICKET_COMMENT_REQUEST,
  UPDATE_TICKET_MATERIAL_REQUEST,

  fetchTicketsSuccess,
  fetchFilterTicketsSuccess,
  fetchTicketSuccess,
  updateTicketTechnicianSuccess,
  updateTicketStatusSuccess,
  createTicketSuccess,
  updateTicketSuccess,
  closeTicketSuccess,
  createTicketCommentSuccess,
  deleteTicketCommentSuccess,
  updateTicketMaterialSuccess,

  fetchTicketsFailure,
  fetchFilterTicketsFailure,
  fetchTicketFailure,
  updateTicketTechnicianFailure,
  updateTicketStatusFailure,
  createTicketFailure,
  updateTicketFailure,
  closeTicketFailure,
  createTicketCommentFailure,
  deleteTicketCommentFailure,
  updateTicketMaterialFailure,
  
} from './actions';
import { api } from '../../api';

function* fetchTicketsSaga(action) {
  try {
    const response = yield call(api.getTickets, action.payload); // Pass the function and the args 
    yield put(fetchTicketsSuccess(response.data));
  } catch (error) {
    yield put(fetchTicketsFailure(error.message));
  }
}

function* fetchFilterTicketsSaga(action) {
  try {
    console.log("data filter payload -->",action.payload);
    const response = yield call(api.getFilterTickets, action.payload); // Pass the function and the args 
    yield put(fetchFilterTicketsSuccess(response.data));
  } catch (error) {
    yield put(fetchFilterTicketsFailure(error.message));
  }
}

function* fetchTicketSaga(action) {
  try {
    // console.log("data ticket saga-->", action);
    const response = yield call(api.getTicket,action.payload); // Pass the function and the args 
    yield put(fetchTicketSuccess(response.data));
  } catch (error) {
    yield put(fetchTicketFailure(error.message));
  }
}

function* updateTicketTechnicianSaga(action) {
  try {
    const { ticketId, technicianData } = action.payload;
    const response = yield call(api.updateTicketTechnician, ticketId, technicianData); // Pass the function and the args 
    yield put(updateTicketTechnicianSuccess(response.data));
  } catch (error) {
    yield put(updateTicketTechnicianFailure(error.message));
  }
}

function* updateTicketStatusSaga(action) {
  try {
    const { ticketId, updateData } = action.payload;
    const response = yield call(api.updateTicketStatus, ticketId, updateData); // Pass the function and the args 
    yield put(updateTicketStatusSuccess(response.data));
  } catch (error) {
    yield put(updateTicketStatusFailure(error.message));
  }
}

function* createTicketSaga(action) {
  try {
    const { data } = action.payload;
    const response = yield call(api.createTicket, data); // Pass the function and the args 
    yield put(createTicketSuccess(response.data));
  } catch (error) {
    yield put(createTicketFailure(error.message));
  }
}

function* updateTicketSaga(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(api.updateTicket, id, data); // Pass the function and the args 
    yield put(updateTicketSuccess(response.data));
  } catch (error) {
    yield put(updateTicketFailure(error.message));
  }
}

function* closeTicketSaga(action) {
  try {
    const response = yield call(api.closeTicket, action.payload); // Pass the function and the args 
    yield put(closeTicketSuccess(response.data));
  } catch (error) {
    yield put(closeTicketFailure(error.message));
  }
}

function* createTicketCommentSaga(action) {
  try {
    const response = yield call(api.createTicketComment, action.payload); // Pass the function and the args 
    yield put(createTicketCommentSuccess(response.data));
  } catch (error) {
    yield put(createTicketCommentFailure(error.message));
  }
}

function* deleteTicketCommentSaga(action) {
  try {
    const response = yield call(api.deleteTicketComment, action.payload); // Pass the function and the args 
    yield put(deleteTicketCommentSuccess(response.data));
  } catch (error) {
    yield put(deleteTicketCommentFailure(error.message));
  }
}

function* updateTicketMaterialSaga(action) {
  try {
    const { id, data } = action.payload;
    console.log("data  ", action.payload);
    const response = yield call(api.updateTicketMaterial, id, data); // Pass the function and the args 
    yield put(updateTicketMaterialSuccess(response.data));
  } catch (error) {
    yield put(updateTicketMaterialFailure(error.message));
  }
}

export function* watchFilterFetchTickets() {
  yield takeEvery(FETCH_FILTER_TICKETS_REQUEST, fetchFilterTicketsSaga);
}

export function* watchFetchTickets() {
  yield takeEvery(FETCH_TICKETS_REQUEST, fetchTicketsSaga);
}

export function* watchFetchTicket() {
  yield takeEvery(FETCH_TICKET_REQUEST, fetchTicketSaga);
}

export function* watchUpdateTicketTechnician() {
  yield takeEvery(UPDATE_TICKET_TECHNICIAN_REQUEST, updateTicketTechnicianSaga);
}

export function* watchUpdateTicketStatus() {
  yield takeEvery(UPDATE_TICKET_STATUS_REQUEST, updateTicketStatusSaga);
}

export function* watchCreateTicket() {
  yield takeEvery(CREATE_TICKET_REQUEST, createTicketSaga);
}

export function* watchUpdateTicket() {
  yield takeEvery(UPDATE_TICKET_REQUEST, updateTicketSaga);
}

export function* watchCloseTicket() {
  yield takeEvery(CLOSE_TICKET_REQUEST, closeTicketSaga);
}

export function* watchCreateTicketComment() {
  yield takeEvery(CREATE_TICKET_COMMENT_REQUEST, createTicketCommentSaga);
}

export function* watchDeleteTicketComment() {
  yield takeEvery(DELETE_TICKET_COMMENT_REQUEST, deleteTicketCommentSaga);
}

export function* watchUpdateMaterialTicket() {
  yield takeEvery(UPDATE_TICKET_MATERIAL_REQUEST, updateTicketMaterialSaga);
}